<template>
  <div class="take-out">
    <Form ref="setting"
          :model="setting"
          :label-width="200">
      <Divider>{{$t('pages_settings_take_out_1017')}}</Divider>
      <FormItem :label="$t('pages_settings_take_out_1018')">
        <i-switch v-model="setting.support_inner_eat"
                  size="large">
          <span slot="open">{{$t('libs_table_render_50')}}</span>
          <span slot="close">{{$t('directives_index_41')}}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_take_out_1019')" v-if="setting.support_inner_eat">
        <TimeRangeGroup start-key="start_at"
                        end-key="end_at"
                        :placeholders="[$t('pages_enough_consume_discount_index_484'), $t('pages_enough_consume_discount_index_485'), $t('pages_settings_take_out_1020')]"
                        v-model="setting.inner_eat_duration" />
        <Tooltip :content="$t('pages_settings_take_out_1021')" placement="right">
          <Icon type="ios-help-circle" />
        </Tooltip>
      </FormItem>
      <Divider>{{$t('pages_settings_take_out_1022')}}</Divider>
      <FormItem :label="$t('pages_settings_take_out_1023')">
        <i-switch v-model="setting.support_self_fetch"
                  size="large">
          <span slot="open">{{$t('libs_table_render_50')}}</span>
          <span slot="close">{{$t('directives_index_41')}}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_take_out_1024')" v-if="setting.support_self_fetch">
        <TimeRangeGroup start-key="start_at"
                        end-key="end_at"
                        :placeholders="[$t('pages_enough_consume_discount_index_484'), $t('pages_enough_consume_discount_index_485'), $t('pages_settings_take_out_1020')]"
                        v-model="setting.self_fetch_duration" />
        <Tooltip :content="$t('pages_settings_take_out_1025')" placement="right">
          <Icon type="ios-help-circle" />
        </Tooltip>
      </FormItem>
      <Divider>{{$t('pages_settings_take_out_1026')}}</Divider>
      <FormItem :label="$t('pages_settings_take_out_1027')">
        <i-switch v-model="setting.support_delivery"
                  size="large">
          <span slot="open">{{$t('libs_table_render_50')}}</span>
          <span slot="close">{{$t('directives_index_41')}}</span>
        </i-switch>
      </FormItem>
      <template v-if="setting.support_delivery">
        <FormItem style="max-width: 700px"
                  :label="$t('pages_settings_take_out_1028')">
          <i-select v-model="setting.delivery_method">
            <i-option v-for="item in express_methods"
                      :key="item.id"
                      :value="item.value">{{item.name}}</i-option>
          </i-select>
        </FormItem>
        <template v-if="setting.delivery_method === 'takeout'">
          <FormItem :label="$t('pages_settings_take_out_1029')">
            <i-switch v-model="setting.auto_confirm"
                      size="large">
              <span slot="open">{{$t('libs_table_render_50')}}</span>
              <span slot="close">{{$t('directives_index_41')}}</span>
            </i-switch>
          </FormItem>
          <FormItem :label="$t('pages_settings_take_out_1030')"
                    style="max-width: 700px">
            <i-input v-model="setting.call_delivery_after"
                    type="number"
                    :placeholder="$t('pages_settings_take_out_1031')">
              <span slot="append">{{$t('pages_settings_take_out_1032')}}</span>
            </i-input>
          </FormItem>
          <FormItem :label="$t('pages_settings_take_out_1033')"
                    style="max-width: 700px">
            <i-input v-model="setting.auto_cancel_after"
                    type="number"
                    :placeholder="$t('pages_settings_take_out_1031')">
              <span slot="append">{{$t('pages_settings_take_out_1032')}}</span>
            </i-input>
          </FormItem>
        </template>
        <FormItem :label="$t('pages_settings_take_out_1031')"
                  style="max-width: 700px">
          <i-input v-model="setting.minimum_delivery_amount"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1031')" />
        </FormItem>
        <FormItem :label="$t('pages_settings_take_out_1034')"
                  style="max-width: 700px">
          <i-input v-model="setting.max_delivery_distance"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1034')">
            <span slot="append">{{$t('pages_settings_take_out_1035')}}</span>
          </i-input>
        </FormItem>
        <FormItem style="max-width: 700px"
                  :label="$t('pages_settings_take_out_1036')">
          <i-select v-model="setting.express_category">
            <i-option v-for="item in express_items"
                      :key="item.id"
                      :value="item.value">{{item.name}}</i-option>
          </i-select>
        </FormItem>
        <FormItem v-if="setting.express_category === 'regular'"
                  :label="$t('pages_orders_show_677')"
                  style="max-width: 700px">
          <i-input v-model="setting.fixed_freight"
                  type="number"
                  :placeholder="$t('pages_orders_show_677')" />
        </FormItem>
        <FormItem class="start-express-price" v-if="setting.express_category === 'by_distance'"
                  :label="$t('pages_settings_take_out_1037')"
                  style="max-width: 700px">
          <i-input v-model="minimum_freight_distance.price"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1038')">
            <span slot="append">{{$t('pages_enough_consume_discount_rule_list_494')}}</span>
          </i-input>
          <i-input v-model="minimum_freight_distance.distance"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1039')">
            <span slot="append">{{$t('pages_settings_take_out_1040')}}</span>
          </i-input>
        </FormItem>
        <FormItem v-if="setting.express_category === 'by_distance'"
                  :label="$t('pages_settings_take_out_1041')"
                  style="max-width: 700px">
          <i-input v-model="setting.freight_per_km"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1042')" />
        </FormItem>
        <FormItem :label="$t('pages_settings_take_out_1043')">
          <TimeRangeGroup start-key="start_at"
                          end-key="end_at"
                          :placeholders="[$t('pages_enough_consume_discount_index_484'), $t('pages_enough_consume_discount_index_485'), $t('pages_settings_take_out_1020')]"
                          v-model="setting.delivery_duration" />
          <Tooltip :content="$t('pages_settings_take_out_1044')" placement="right">
            <Icon type="ios-help-circle" />
          </Tooltip>
        </FormItem>
      </template>
      <template v-if="setting.support_self_fetch || setting.support_delivery">
        <FormItem :label="$t('pages_settings_take_out_1045')"
                  style="max-width: 700px">
          <i-input v-model="setting.package_amount"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1045')" />
        </FormItem>
        <FormItem :label="$t('pages_settings_take_out_1046')"
                  style="max-width: 700px">
          <i-input v-model="setting.address"
                  :placeholder="$t('pages_settings_take_out_1047')">
            <Button slot="append" @click="getLatlng">{{$t('pages_settings_take_out_1048')}}</Button>
          </i-input>
          <Tooltip :content="$t('pages_settings_take_out_1049')" placement="right">
            <Icon type="ios-help-circle" />
          </Tooltip>
        </FormItem>
        <FormItem :label="$t('pages_settings_take_out_1050')"
                  style="max-width: 700px">
          <i-input v-model="setting.longitude"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1051')" />
        </FormItem>
        <FormItem :label="$t('pages_settings_take_out_1052')"
                  style="max-width: 700px">
          <i-input v-model="setting.latitude"
                  type="number"
                  :placeholder="$t('pages_settings_take_out_1053')" />
        </FormItem>
      </template>
      <Form-item>
        <Button type="primary" @click="handleSubmit">{{$t('pages_combo_index_284')}}</Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'
// import axios from 'axios'
import TimeRangeGroup from './TimeRangeGroup';
// import { isApp } from '@/libs/util';

export default {
  components: {
    TimeRangeGroup,
  },
  data () {
    return {
      express_methods: [{
        id: 1,
        name: i18n.t('libs_table_render_55'),
        value: 'merchant_send'
      }, {
        id: 2,
        name: i18n.t('pages_settings_take_out_1054'),
        value: 'takeout'
      }, {
        id: 3,
        name: i18n.t('libs_table_render_57'),
        value: 'express'
      }],
      express_items: [{
        id: 1,
        name: i18n.t('pages_settings_take_out_1055'),
        value: 'regular'
      }, {
        id: 2,
        name: i18n.t('pages_settings_take_out_1056'),
        value: 'by_distance'
      }, {
        id: 3,
        name: i18n.t('pages_settings_take_out_1057'),
        value: 'by_city'
      }]
    }
  },
  created () {
    this.display()
  },
  computed: {
    ...mapGetters('delivery_setting', { setting: 'delivery_setting' }),
    minimum_freight_distance () {
      const { price, distance } = this.setting.minimum_freight_by_minimum_distance || {}
      return { price: price || 0, distance: distance || 0 }
    }
  },
  methods: {
    ...mapActions('delivery_setting', ['display', 'upgrade', 'geocoder']),
    // goLbs () {
    //   const url = 'https://lbs.qq.com/getPoint/'
    //   isApp() ? window.open(url, 'lbs_point', 'height=610, width=800, top=50, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no') : window.open(url)
    // },
    getLatlng () {
      const { address } = this.setting
      if (!address) {
        return this.$Message.warning(i18n.t('pages_settings_take_out_1058'))
      }
      this.geocoder({
        address
      }).then(data => {
        const { status, result } = data
        // console.info('getLatlng', result, address_components, location)
        if (status !== 0 && !result) {
          return this.$Message.warning(i18n.t('pages_settings_take_out_1059'))
        }
        const { location: { lng, lat } } = result
        this.setting.longitude = lng
        this.setting.latitude = lat
      })
    },
    handleSubmit () {
      const { support_self_fetch, support_delivery, address, longitude, latitude } = this.setting
      if (support_self_fetch || support_delivery) {
        if (!address || !longitude || !latitude) {
          return this.$Message.warning(i18n.t('pages_promote_setting_bak_910'))
        }
      }
      this.setting.minimum_freight_by_minimum_distance = {
        price: parseFloat(this.minimum_freight_distance.price),
        distance: parseFloat(this.minimum_freight_distance.distance)
      }
      this.upgrade(this.setting)
    }
  }
}
</script>

<style lang="scss" scoped>
  .take-out {
    .start-express-price {
      .ivu-form-item-content {
        display: flex;
      }
    }
  }
</style>
